// extracted by mini-css-extract-plugin
export default {"antInput":"buyCourse_antInput__14NmU"};